export const DEFAULT_POSTHOG_HTTP_ERROR_EVENT = 'HTTP_REQUEST_FAIL';

export const POSTHOG_HTTP_ERROR_EVENT_MAPPING: {
  eventName: string;
  pattern: RegExp;
}[] = [
  { eventName: 'BASKET_V1_QUOTE_REQUEST_FAIL', pattern: /(^|\/)v1\/quote$/ },
  { eventName: 'BASKET_V2_QUOTE_REQUEST_FAIL', pattern: /(^|\/)v2\/quote$/ },
  {
    eventName: 'BASKET_V2_ADD_QUOTE_TO_BASKET_REQUEST_FAIL',
    pattern: /(^|\/)v2\/addQuoteToBasket$/,
  },
  {
    eventName: 'BASKET_V1_ADD_APPLIANCES_REQUEST_FAIL',
    pattern: /(^|\/)v1\/add-appliances$/,
  },
  {
    eventName: 'BASKET_V1_REMOVE_APPLIANCES_REQUEST_FAIL',
    pattern: /(^|\/)v1\/remove-appliances$/,
  },
  {
    eventName: 'USER_V1_GET_CUSTOMER_STATUS_REQUEST_FAIL',
    pattern: /(^|\/)v1\/get-customer-status$/,
  },
  {
    eventName: 'CATALOGUE_V1_APPLIANCES_BRANDS_REQUEST_FAIL',
    pattern: /(^|\/)v1\/appliances\/[^/]+\/brands$/,
  },
  {
    eventName: 'CATALOGUE_V1_CATALOGUE_REQUEST_FAIL',
    pattern: /(^|\/)v1\/catalogue\/[^/]+$/,
  },
  {
    eventName: 'AUTH_V2_CREATE_SESSION_REQUEST_FAIL',
    pattern: /(^|\/)v2\/create-session$/,
  },
  {
    eventName: 'COMMON_V2_DIRECT_DEBIT_VALIDATE_REQUEST_FAIL',
    pattern: /(^|\/)v2\/direct-debit\/validate$/,
  },
  {
    eventName: 'BASKET_V1_CHECKOUT_REQUEST_FAIL',
    pattern: /(^|\/)v1\/checkout$/,
  },
  {
    eventName: 'BASKET_V2_CHECKOUT_REQUEST_FAIL',
    pattern: /(^|\/)v2\/checkout$/,
  },
  {
    eventName: 'COMMON_V2_REGISTER_REQUEST_FAIL',
    pattern: /(^|\/)v2\/register$/,
  },
  {
    eventName: 'COMMON_V3_REGISTER_REQUEST_FAIL',
    pattern: /(^|\/)v3\/register$/,
  },
  {
    eventName: 'APPLIANCE_MODEL_V1_TYPEAHEAD_REQUEST_FAIL',
    pattern: /(^|\/)v1\/typeahead$/,
  },
  {
    eventName: 'APPLIANCE_MODEL_V1_SESSION_REQUEST_FAIL',
    pattern: /(^|\/)v1\/session$/,
  },
  {
    eventName: 'ADDRESSY_FIND_REQUEST_FAIL',
    pattern: /Capture\/Interactive\/Find\/v1\.1\/json3\.ws$/,
  },
  {
    eventName: 'ADDRESSY_RETRIEVE_REQUEST_FAIL',
    pattern: /Capture\/Interactive\/Retrieve\/v1\.1\/json3\.ws$/,
  },
];
